import React from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";

const { Content } = Layout;
const FrontLayout = () => {
  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <Layout>
          <Content className="bg-black" >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default FrontLayout;
